import React, { useEffect, useState } from 'react';
import '../../styles/EventsStyle.css';
import moment from 'moment';
import { BiChevronRightCircle, BiFilter, BiFilterAlt } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../settings';
import { displaySnackbar } from '../../utilities';

export default function Events({ events, fetchEvents }) {
    const navigate = useNavigate();
    const [selectedFilter, setSelectedFilter] = useState('All');

    useEffect(() => {
        fetchEvents();
    }, []);

    useEffect(() => {
        fetchEvents();
    }, [selectedFilter]);

    const filterd_events = events.filter((item) => {
        if (selectedFilter === 'overdue') {
            return new Date().getTime() > new Date(item?.endDate).getTime();
        } else if (selectedFilter === 'Today') {
            return moment(new Date(item?.startDate)).calendar().includes('Today');
        } else if (selectedFilter === 'later')
            return new Date(item?.startDate).getDate() > new Date().getDate();
        else if (selectedFilter === 'In Progress') {
            return (
                new Date(item?.startDate).getDate() < new Date().getDate() &&
                new Date(item?.endDate).getDate() > new Date().getDate()
            );
        } else return true;
    });

    return (
        <div className='events'>
            <div className='header'>
                <button className='go-back-btn' onClick={() => navigate(-1)}>
                    👈️ Go back
                </button>

                <h1 className='headerText'>Events</h1>
            </div>

            <div className='events-filter-container'>
                <button
                    style={{
                        backgroundColor: selectedFilter === 'All' ? 'darkblue' : 'transparent',
                        color: selectedFilter === 'All' ? '#eee' : '#333',
                    }}
                    onClick={() => setSelectedFilter('All')}
                >
                    <span>All {<BiFilterAlt size={25} />}</span>
                </button>
                <button
                    style={{
                        backgroundColor: selectedFilter === 'overdue' ? 'darkblue' : 'transparent',
                        color: selectedFilter === 'overdue' ? '#eee' : '#333',
                    }}
                    onClick={() => setSelectedFilter('overdue')}
                >
                    <span>Overdue {<BiFilterAlt size={25} />}</span>
                </button>
                <button
                    style={{
                        backgroundColor: selectedFilter === 'Today' ? 'darkblue' : 'transparent',
                        color: selectedFilter === 'Today' ? '#eee' : '#333',
                    }}
                    onClick={() => setSelectedFilter('Today')}
                >
                    <span>Today {<BiFilterAlt size={25} />}</span>
                </button>
                <button
                    style={{
                        backgroundColor:
                            selectedFilter === 'In Progress' ? 'darkblue' : 'transparent',
                        color: selectedFilter === 'In Progress' ? '#eee' : '#333',
                    }}
                    onClick={() => setSelectedFilter('In Progress')}
                >
                    <span>In Progress {<BiFilterAlt size={25} />}</span>
                </button>
                <button
                    onClick={() => setSelectedFilter('later')}
                    style={{
                        backgroundColor: selectedFilter === 'later' ? 'darkblue' : 'transparent',
                        color: selectedFilter === 'later' ? '#eee' : '#333',
                    }}
                >
                    <span>Later {<BiFilterAlt size={25} />}</span>
                </button>
            </div>

            {filterd_events.length <= 0 ? (
                <div className='empty-events-container'>
                    <p className='events-empty-text'>No {selectedFilter} Events</p>

                    <div
                        xyz='fade large duration-20  iterate-infinite'
                        className='events-emptyEmojisDiv'
                    >
                        <p className='events-emptyEmojis xyz-nested'>📆</p>
                    </div>
                </div>
            ) : (
                <div className='events-list'>
                    {filterd_events.map((item, index) => (
                        <div
                            key={`event-item #${index}`}
                            className='event-item'
                            style={{ borderLeft: `.5rem solid ${item?.color}` }}
                        >
                            <div className='left'>
                                <p
                                    className='event-item-name'
                                    style={{ backgroundColor: item.color }}
                                    onClick={() => navigate(`/info/eventDetail/${item?.uuid}`)}
                                >
                                    {item.name}
                                    <BiChevronRightCircle size={30} className='icon' />
                                </p>
                                <p className='event-item-startDate'>
                                    starting: (
                                    {new Date(item?.startDate).toISOString().slice(0, 10)}){' '}
                                    {moment(new Date(item?.startDate)).fromNow()}
                                </p>
                                <p className='event-item-endDate'>
                                    ending: ({new Date(item?.endDate).toISOString().slice(0, 10)}){' '}
                                    {moment(new Date(item?.endDate)).fromNow()}{' '}
                                </p>
                            </div>
                            <div className='right'></div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
